export default __webpack_public_path__ + "static/media/TaskExample.ef3baebd.png";